import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { ShieldCheck, PhoneCall, Mail, MapPinned, Clock3, Wifi, Menu, X } from 'lucide-react';
const navLinks = [{
  to: '/commercial',
  label: 'Commercial'
}, {
  to: '/smart-home',
  label: 'Smart Home'
}, {
  to: '/services',
  label: 'Solutions'
}, {
  to: '/industries',
  label: 'Industries'
}, {
  to: '/process',
  label: 'Process'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/contact',
  label: 'Contact'
}];
function Header() {
  const [open, setOpen] = useState(false);
  return <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-slate-950/85 backdrop-blur-xl" data-id="element-26">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8" data-id="element-27">
        <Link to="/" className="flex items-center gap-3" data-id="element-28">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-400 text-slate-950 shadow-lg shadow-sky-500/20" data-id="element-29">
            <ShieldCheck className="h-6 w-6" data-id="element-30" />
          </div>
          <div data-id="element-31">
            <p className="text-lg font-black tracking-tight text-white" data-id="element-32">
              Watchdog Security
            </p>
            <p className="text-xs font-medium text-slate-400" data-id="element-33">
              Commercial • Residential • Smart Protection
            </p>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 text-sm font-semibold text-slate-300 lg:flex" data-id="element-34">
          {navLinks.map(l => <NavLink key={l.to} to={l.to} className={({
          isActive
        }) => `transition hover:text-white ${isActive ? 'text-white' : ''}`} data-id="element-35">
              {l.label}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-3 md:flex" data-id="element-36">
          <a href="tel:+19168424729" className="text-sm font-bold text-slate-300 hover:text-white" data-id="element-37">
            (916) 842-4729
          </a>
          <Link to="/assessment" className="rounded-2xl bg-white px-5 py-3 text-sm font-black text-slate-950 transition hover:bg-sky-100" data-id="element-38">
            Free Assessment
          </Link>
        </div>

        <button aria-label="Toggle menu" onClick={() => setOpen(!open)} className="text-white md:hidden" data-id="element-39">
          {open ? <X className="h-6 w-6" data-id="element-40" /> : <Menu className="h-6 w-6" data-id="element-41" />}
        </button>
      </div>

      {open && <div className="border-t border-white/10 bg-slate-950 px-4 py-4 md:hidden" data-id="element-42">
          <div className="grid gap-2" data-id="element-43">
            {navLinks.map(l => <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="rounded-xl px-3 py-3 text-sm font-bold text-slate-200 hover:bg-white/10" data-id="element-44">
                {l.label}
              </NavLink>)}
            <Link to="/assessment" onClick={() => setOpen(false)} className="mt-2 rounded-xl bg-sky-400 px-3 py-3 text-center text-sm font-black text-slate-950" data-id="element-45">
              Free Assessment
            </Link>
            <a href="tel:+19168424729" className="rounded-xl bg-white/10 px-3 py-3 text-center text-sm font-bold text-white" data-id="element-46">
              Call (916) 842-4729
            </a>
          </div>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="bg-slate-950 px-4 py-14 text-white sm:px-6 lg:px-8" data-id="element-47">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.1fr_.7fr_.7fr_.9fr]" data-id="element-48">
        <div data-id="element-49">
          <div className="flex items-center gap-3" data-id="element-50">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-400 text-slate-950" data-id="element-51">
              <ShieldCheck className="h-6 w-6" data-id="element-52" />
            </div>
            <div data-id="element-53">
              <p className="text-lg font-black" data-id="element-54">Watchdog Security</p>
              <p className="text-xs text-slate-400" data-id="element-55">
                Smarter protection for the places people depend on.
              </p>
            </div>
          </div>
          <p className="mt-6 max-w-md leading-7 text-slate-400" data-id="element-56">
            Commercial security, smart home protection, cameras, access control,
            alarms, repairs, automation, and local support across Northern
            California.
          </p>
        </div>

        <div data-id="element-57">
          <h4 className="font-black" data-id="element-58">Solutions</h4>
          <div className="mt-4 grid gap-3 text-sm text-slate-400" data-id="element-59">
            <Link to="/services/access-control" className="hover:text-white" data-id="element-60">
              Access Control
            </Link>
            <Link to="/services/video-surveillance" className="hover:text-white" data-id="element-61">
              Video Surveillance
            </Link>
            <Link to="/services/intrusion-detection" className="hover:text-white" data-id="element-62">
              Intrusion Detection
            </Link>
            <Link to="/smart-home" className="hover:text-white" data-id="element-63">
              Smart Home Security
            </Link>
            <Link to="/services/repairs" className="hover:text-white" data-id="element-64">
              Repairs and Upgrades
            </Link>
            <Link to="/services/multi-site" className="hover:text-white" data-id="element-65">
              Multi Site Management
            </Link>
          </div>
        </div>

        <div data-id="element-66">
          <h4 className="font-black" data-id="element-67">Company</h4>
          <div className="mt-4 grid gap-3 text-sm text-slate-400" data-id="element-68">
            <Link to="/about" className="hover:text-white" data-id="element-69">
              About
            </Link>
            <Link to="/process" className="hover:text-white" data-id="element-70">
              Our Process
            </Link>
            <Link to="/industries" className="hover:text-white" data-id="element-71">
              Industries
            </Link>
            <Link to="/contact" className="hover:text-white" data-id="element-72">
              Contact
            </Link>
            <Link to="/assessment" className="hover:text-white" data-id="element-73">
              Free Assessment
            </Link>
          </div>
        </div>

        <div data-id="element-74">
          <h4 className="font-black" data-id="element-75">Contact</h4>
          <div className="mt-4 grid gap-4 text-sm text-slate-400" data-id="element-76">
            <a href="tel:+19168424729" className="flex items-center gap-3 hover:text-white" data-id="element-77">
              <PhoneCall className="h-4 w-4 text-sky-300" data-id="element-78" /> (916) 842-4729
            </a>
            <a href="https://www.alarm.com/US/watchdogsmarthome?home=1" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white" data-id="element-79">
              <Wifi className="h-4 w-4 text-sky-300" data-id="element-80" /> Customer Login
            </a>
            <div className="flex items-start gap-3" data-id="element-81">
              <MapPinned className="mt-0.5 h-4 w-4 flex-none text-sky-300" data-id="element-82" />
              <span data-id="element-83">1021 Kirby Ct, Folsom, CA 95630</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-84">
              <Clock3 className="mt-0.5 h-4 w-4 flex-none text-sky-300" data-id="element-85" />
              <div data-id="element-86">
                <p data-id="element-87">Mon–Fri: 7 AM – 9 PM</p>
                <p data-id="element-88">Sat–Sun: 8 AM – 8 PM</p>
              </div>
            </div>
          </div>
          <Link to="/assessment" className="mt-6 inline-flex rounded-2xl bg-sky-400 px-5 py-3 text-sm font-black text-slate-950 hover:bg-sky-300" data-id="element-89">
            Free Assessment
          </Link>
        </div>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center" data-id="element-90">
        <p data-id="element-91">
          © {new Date().getFullYear()} Watchdog Security. All rights reserved.
        </p>
        <p data-id="element-92">California License: Add official license number here.</p>
      </div>
    </footer>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}
export function Layout() {
  return <div className="min-h-screen bg-slate-50 text-slate-950" data-id="element-93">
      <ScrollToTop data-id="element-94" />
      <Header data-id="element-95" />
      <main data-id="element-96">
        <Outlet data-id="element-97" />
      </main>
      <Footer data-id="element-98" />
    </div>;
}